import React, { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { Button } from "semantic-ui-react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { BaseUrlInvoice } from "../formcomponents/Constants";
import PerformaInvoicePrintView, {
  mapPerformaApiToPdf,
  PERFORMA_PRINT_PAGE_STYLE,
  suppressPerformaPrintChrome,
} from "./PerformaInvoicePrintView";

const PerformaInvoicePdf = () => {
  const componentRef = useRef();
  const { id } = useParams();
  const [dataObject, setDataObject] = useState({});
  const [loading, setLoading] = useState(true);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: " ",
    pageStyle: PERFORMA_PRINT_PAGE_STYLE,
    onBeforePrint: suppressPerformaPrintChrome,
    onAfterPrint: () => alert("print SUCCESS"),
  });

  useEffect(() => {
    if (!id) {
      setLoading(false);
      return;
    }
    setLoading(true);
    axios
      .post(BaseUrlInvoice + "accounts/getPerformaInvoiceDetails", {
        ssPerformaInvoiceId: id,
      })
      .then((res) => {
        setDataObject(mapPerformaApiToPdf(res.data));
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, [id]);

  return (
    <>
      <div style={{ padding: 10, marginBottom: 35 }}>
        <Button
          floated="right"
          onClick={handlePrint}
          disabled={loading}
        >
          print
        </Button>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "50px",
          boxSizing: "border-box",
        }}
      >
        {loading ? (
          <p>Loading invoice...</p>
        ) : (
          <PerformaInvoicePrintView
            ref={componentRef}
            dataObject={dataObject}
          />
        )}
      </div>
    </>
  );
};

export default PerformaInvoicePdf;
